import React from "react";
import { useTranslation } from "react-i18next";
import { getPermissions } from "../../../../../store/roleManagement/roleManagementSlice";
import ResourcePage from "./shared/ResourcePage";

const thunks = { fetch: getPermissions };

const PermissionsPage = () => {
  const { t } = useTranslation();

  const columns = [
    { key: "name", label: t("pages.role_management.name") },
    { key: "key", label: t("pages.role_management.key") },
  ];

  return (
    <ResourcePage
      resource="permissions"
      singular="permission"
      readOnly
      paginated={false}
      columns={columns}
      viewFields={columns}
      thunks={thunks}
    />
  );
};

export default PermissionsPage;